module.exports = __webpack_public_path__ + "static/media/pubg.0f9fd676.jpg";